import tokenManager from '../utils/tokenManager';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

/**
 * Get the current project summary status
 */
export const getProjectSummaryStatus = async (projectId) => {
  const token = tokenManager.getToken();
  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await fetch(`${API_BASE_URL}/projects/${projectId}/summary/status`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to get summary status' }));
    throw new Error(error.detail || 'Failed to get summary status');
  }

  return response.json();
};

/**
 * Get the current project summary
 */
export const getProjectSummary = async (projectId) => {
  const token = tokenManager.getToken();
  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await fetch(`${API_BASE_URL}/projects/${projectId}/summary`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to get summary' }));
    throw new Error(error.detail || 'Failed to get summary');
  }

  return response.json();
};

/**
 * Refresh the project summary (generate new one)
 */
export const refreshProjectSummary = async (projectId) => {
  const token = tokenManager.getToken();
  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await fetch(`${API_BASE_URL}/projects/${projectId}/summary/refresh`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Failed to refresh summary' }));
    throw new Error(error.detail || 'Failed to refresh summary');
  }

  return response.json();
};
